var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"height":"50px"}}),_c('Bar3d',{style:({ height: _vm.height, width: _vm.width }),attrs:{"id":_vm.id,"chartData":_vm.chartData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }